import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "./SideMenu";
import Footer from "./Footer";
import Header from "./Header";
import Logout from "./Logout";
import { strings } from "../Utilities/strings";
// for Sidebar And Navbar
import Search from "../images/search.png";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Add_Icon from "../images/Add_Icon.svg";
import Edit_Icon from "../images/edit_icon.svg";
import searchIcon from "../images/search_icon.svg";

//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import { addRoleMaster, getRoleMaster } from "../Utilities/URLCONSTANTS";
import Loader from "../Utilities/Loader";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import * as XLSX from "xlsx";
import Select from "react-select";
import { customStyles, customstyles, modalCustomStyles } from "../Utilities/utils";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../Utilities/Pagination";

//UnitMeasureMaster
const RoleMaster = ({ }) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [id, setId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [Status, setStatus] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [errorName, setErrorName] = useState("");
  const [buttonText, setButtonText] = useState("Submit");
  const [sno, setSno] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState(
    "Do you want to close Unit Measure Master"
  );
  const [loading, setLoading] = useState(false);
  const [deleteItems, setDeleteItems] = useState("");
  ///modal popup
  const [showModal, setShowModal] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [modalData, setModalData] = useState({
    id: "",
    roleName: "",
    description: "",
    status: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  // In your handleFilter function, update filteredData based on searchTerm
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) =>
          item.roleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.status.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filteredResults);
      handlePageClick(1)
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  // Pagination logic
  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key]?.toString().toLowerCase();
      const bValue = b[sortConfig.key]?.toString().toLowerCase();
      if (aValue < bValue)
        return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue)
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  const exportToExcel = () => {
    const data = [
      ["S.no", "Role Name", "Description", "Status"], // Custom headers
      ...filteredData.map((item, index) => [
        index + 1, // Generate sequential serial numbers starting from 1
        item.roleName,
        item.description,
        item.status === "1" ? "Active" : "InActive",
      ]),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Roles");
    XLSX.writeFile(workbook, "RoleMaster.xlsx");
  };

  const handleCancel_new = () => {
    setShowModal(true);
    setShowPopup(true);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const handleCancel = () => {
    setShowModal(true);
    setShowPopup(false);
    setShowMsg(true);
  };
  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  // const handleNameChange = (e) => {
  //   const input = e.target.value;
  //   if (input.length > 0) {
  //     setErrorName("");
  //   }
  //   const result = input.replace(/[^a-z_\s]/gi, "");
  //   setRoleName(result);
  // };

  const formatRoleName = (value) => {
    return value
      .replace(/[^a-zA-Z_\s]/g, "")
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
  };

  const handleNameChange = (e) => {
    const input = e.target.value;
    if (input.length > 0) {
      setErrorName("");
    }
    const result = formatRoleName(input);
    setRoleName(result);
  };


  const handleStatus = (e) => {
    setStatus(e.target.value);
    if (e.target.value) {
      setErrorStatus("");
    }
  };

  // const handleDescriptionChange = (e) => {
  //   const input = e.target.value;
  //   setDescription(input);
  //   if (input.length > 0) {
  //     setErrorDescription("");
  //   }
  // };

  const handleDescriptionChange = (e) => {
    const input = e.target.value;
    const formattedInput = input.replace(
      /\b[a-z]/g,
      (char) => char.toUpperCase()
    );
    setDescription(formattedInput);
    if (input.length > 0) {
      setErrorDescription("");
    }
  };


  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "In Active" },
  ];

  const handleSubmit = async () => {
    if (roleName === "") {
      setErrorName("Please Enter   RoleName");
    }
    if (description === "") {
      setErrorDescription("Please Enter  Description");
    }
    if (Status === "") {
      setErrorStatus("Please Select Status");
    }

    try {
      if (roleName != "" && description != "" && Status != "") {
        const apiUrl = addRoleMaster;
        const dataToSend = {
          Id: { buttonText } == "Submit" ? "" : id,
          roleName: roleName,
          description: description,
          Status: Status,
        };
        const headers = await GetApiHeaders();
        setIsLoading(true);
        // Make the POST request using Axios with headers
        const response = await axios.post(apiUrl, dataToSend, { headers });
        setsubmitResponse(response.data.response);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);
        // Handle the response data as needed
        console.log("Response:", response.data);

        // Proceed with data insertion if the API call was successful
        const newId = String(Date.now());
        const newItem = {
          id: newId,
          roleName: roleName,
          description: description,
          status: data.status,
        };

        setErrorName("");
        setErrorDescription("");
        setErrorStatus("");
        setIsSubmitted(true);
        // setData(prevData => [...prevData, newItem]);
      } else {
        setIsSubmitted(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsSubmitted(false);
      handleUpdate();
    } finally {
    }
  };

  const handleUpdate = () => {
    if (id !== "" && roleName !== "" && description !== "" && Status !== "") {
      setErrorName("");
      setErrorDescription("");
      setErrorStatus("");
      setIsUpdated(true);
    } else {
      setIsUpdated(false);
    }
  };

  const fetchData = async () => {
    const apiUrl = getRoleMaster;
    const headers = await GetApiHeaders();
    console.log("Dynamic Headers::", headers);

    setIsLoading(true);
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        setIsLoading(false);
        console.log("response", response);
        setData(response.data.response.roleMaster);
        setLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId("");
    setRoleName("");
    setDescription("");
    setStatus("");
    setModalData({
      id: "",
      roleName: "",
      description: "",
      status: "",
    });
  };

  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };

  const updatedItems = (item) => {
    // setModalData(item)
    setId(item.id);
    setRoleName(item.roleName);
    setDescription(item.description);
    setStatus(item.status);
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(false);
  };



  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">User Management</h5>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0 Sub_role_text"> Role Master</h6>
                      </div>
                      <span
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Add Role"
                      >
                        <Button
                          className="buttons"
                          variant="primary"
                          onClick={handleModalOpen}
                        >
                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label> Entries</label>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />

                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />

                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <button
                          className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                          onClick={exportToExcel}
                        >
                          Download Excel
                        </button>
                      </div>
                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div className="card-body">
                          <Table className="table table-bordered Content_data_table table-striped">
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("roleName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Role Name
                                    {renderSortIcon("roleName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("description")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Description
                                    {renderSortIcon("description")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("status")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Status
                                    {renderSortIcon("status")}
                                  </span>
                                </Th>
                                <Th className="text-center">Actions</Th>
                              </Tr>
                            </Thead>

                            <Tbody>
                              {currentItems.length === 0 ? ( // Check if no data is found
                                <Tr>
                                  <Td
                                    colSpan={13}
                                    className="text-center"
                                    style={{ padding: 195, fontSize: 18 }}
                                  >
                                    Data is not available
                                  </Td>
                                </Tr>
                              ) : (
                                currentItems.map((item, index) => (
                                  <Tr>
                                    <Td className="text-left">{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                    <Td className="text-left">
                                      {item.roleName}
                                    </Td>
                                    <Td className="text-left">
                                      {item.description}
                                    </Td>
                                    <Td className="text-center">
                                      {item.status === "1" ? (
                                        <span style={{ color: "#4A7729" }}>
                                          Active
                                        </span>
                                      ) : (
                                        <span style={{ color: "#FF0000" }}>
                                          In Active
                                        </span>
                                      )}
                                    </Td>

                                    <Td
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div>
                                        <img
                                          src={Edit_Icon}
                                          alt="Edit Role"
                                          title="Edit Role"
                                          className="editicon"
                                          onClick={() => updatedItems(item)}
                                        />
                                      </div>
                                    </Td>
                                  </Tr>
                                ))
                              )}
                            </Tbody>
                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                          {/* Pagination */}
                          <Pagination
                            currentPage={currentPage}
                            totalItems={sortedData.length}
                            itemsPerPage={itemsPerPage}
                            currentItems={currentItems}
                            onPageChange={handlePageClick}
                          />
                        </div>
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel_new}
                              >
                                {" "}
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">Role Master</span>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    for="exampleInputPassword1"
                                    class="form-label text-md font-weight-600 mb-0"
                                  >
                                    Role Name
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Role Name"
                                      value={roleName}
                                      inputMode="text"
                                      onChange={handleNameChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorName}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <div class="mb-3">
                                    <label
                                      for="exampleInputPassword1"
                                      class="form-label text-md font-weight-600 mb-0"
                                    >
                                      Description
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <textarea
                                      class="description form-control"
                                      style={{ height: 115 }}
                                      id="textAreaExample1"
                                      rows="2"
                                      value={description}
                                      onChange={handleDescriptionChange}
                                    ></textarea>
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorDescription}
                                  </span>
                                </div>
                                <div
                                  className="col-md-6 custom-margin"
                                >
                                  <label
                                    for="Input"
                                    class="form-label text-md font-weight-600 mb-0"
                                  >
                                    Status
                                  </label>
                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={statusOptions}
                                      value={statusOptions.find(
                                        (option) => option.value === Status
                                      )}
                                      onChange={(selectedOption) =>
                                        handleStatus({
                                          target: { value: selectedOption?.value || "" },
                                        })
                                      }
                                      placeholder="Select Status"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorStatus}
                                  </span>
                                </div>
                              </div>
                              &nbsp;
                              <div className="row">
                                {isSubmitted ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.recordSubmitted}.
                                  </p>
                                ) : null}
                                {isUpdated ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.updatedSuccessfully}
                                  </p>
                                ) : null}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="btnn"
                                  onClick={() =>
                                    handleSubmit({
                                      id,
                                      roleName,
                                      description,
                                      Status,
                                    })
                                  }
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>
                                <Button
                                  variant="danger"
                                  className="btnn"
                                  onClick={handleCancel_new}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            className="modalBlur"
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Role Master</span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close this Window
                                    ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showWarningPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Role Master</span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p className="text-center Popup_Text_Colour">
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Role Master</span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p className="text-center Popup_Text_Colour">
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                  {loading && (
                    <div>
                      <p>Fetching data. Please wait...</p>
                      <Loader
                        height="80"
                        width="80"
                        radius="9"
                        color="#4A7729"
                        ariaLabel="loading"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default RoleMaster;
